export enum CurrencyEnum {
  EUR = 'EUR',
  USD = 'USD',
  CFA = 'CFA'
}
